import { Button, Headline, Stack, Tag } from '@servicetitan/design-system';
import styles from '../../CustomerDetails.module.css';
import Location from '../../../Location';
import CustomerCardWrapper from '../CustomerCardWrapper/CustomerCardWrapper';
import { Location as CustomerLocation } from '@api/generated/graphql';

interface CustomerLocationsProps {
  /** A preview of the customer's locations; only the first 3 are shown. */
  locations: CustomerLocation[];
  /** The customer's total number of locations, which can exceed `locations.length`. */
  totalCount: number;
  onViewAllClicked: () => void;
  onLinkOutClicked?: (id: string) => void;
}

const CustomerLocations = ({
  locations,
  totalCount,
  onViewAllClicked,
  onLinkOutClicked,
}: CustomerLocationsProps) => {
  const shouldShowViewAllButton = totalCount > 3;
  const firstThreeLocations = locations.slice(0, 3);

  return (
    <CustomerCardWrapper>
      <Stack className={styles.customerHeader} alignItems='center' spacing={1}>
        <Headline className='m-0' size='small'>
          Location
        </Headline>
        <div className='m-t-half m-b-half'>
          <Tag badge compact>
            {totalCount}
          </Tag>
        </div>
      </Stack>
      <div>
        {firstThreeLocations.map((location) => (
          <Location
            key={location.id}
            address={location.address}
            onLinkOutClicked={
              onLinkOutClicked ? () => onLinkOutClicked(location.id) : undefined
            }
          />
        ))}
        {shouldShowViewAllButton && (
          <Button
            size='xsmall'
            fill='subtle'
            color='primary'
            onClick={onViewAllClicked}
            aria-label='View All'
          >
            View All
          </Button>
        )}
      </div>
    </CustomerCardWrapper>
  );
};

export default CustomerLocations;
